<template>
	<div class="index">
		<div class="div-1">
			<img src="../../assets/module/waimai/waimai-01.jpg" alt="" />
			<img src="../../assets/module/waimai/but.png" alt="" class="div-2" />
		</div>
		<div class="div-1">
			<img src="../../assets/module/waimai/waimai-02.jpg" alt="" />
			<img src="../../assets/module/waimai/but.png" alt="" class="div-2" />
		</div>
		<div class="div-1">
			<img src="../../assets/module/waimai/waimai-03.jpg" alt="" />
			<img src="../../assets/module/waimai/but.png" alt="" class="div-2" />
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	created() {},
	methods: {}
};
</script>

<style>
.index {
	background: #fcf5cc;
	overflow: hidden;
	min-height: 100vh;
}
.index .div-1{
    position: relative;
}
.index img {
    width: 100%;
}
.index .div-2 {
    position: absolute;
    top: .4rem;
    right: .586667rem;
    width: 3.226667rem;
    height: .826667rem;
}
</style>
